'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserDetails$package$UserMiddleName$() {
  this.aGA = null;
  this.aGB = false;
}
export { $c_Lapp_data_UserDetails$package$UserMiddleName$ as $c_Lapp_data_UserDetails$package$UserMiddleName$ };
$p = $c_Lapp_data_UserDetails$package$UserMiddleName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_UserDetails$package$UserMiddleName$;
/** @constructor */
function $h_Lapp_data_UserDetails$package$UserMiddleName$() {
}
export { $h_Lapp_data_UserDetails$package$UserMiddleName$ as $h_Lapp_data_UserDetails$package$UserMiddleName$ };
$h_Lapp_data_UserDetails$package$UserMiddleName$.prototype = $p;
$p.aA = (function() {
  if ((!this.aGB)) {
    this.aGA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aGB = true;
  }
  return this.aGA;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeString__validate__T__O(this, input);
});
var $d_Lapp_data_UserDetails$package$UserMiddleName$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserDetails$package$UserMiddleName$, "app.data.UserDetails$package$UserMiddleName$", ({
  Fg: 1,
  B: 1,
  C: 1,
  J: 1
}));
export { $d_Lapp_data_UserDetails$package$UserMiddleName$ as $d_Lapp_data_UserDetails$package$UserMiddleName$ };
var $n_Lapp_data_UserDetails$package$UserMiddleName$;
function $m_Lapp_data_UserDetails$package$UserMiddleName$() {
  if ((!$n_Lapp_data_UserDetails$package$UserMiddleName$)) {
    $n_Lapp_data_UserDetails$package$UserMiddleName$ = new $c_Lapp_data_UserDetails$package$UserMiddleName$();
  }
  return $n_Lapp_data_UserDetails$package$UserMiddleName$;
}
export { $m_Lapp_data_UserDetails$package$UserMiddleName$ as $m_Lapp_data_UserDetails$package$UserMiddleName$ };
//# sourceMappingURL=app.data.-User-Details$package$-User-Middle-Name$.js.map
